module.exports = __webpack_public_path__ + "static/gitex-logo-6e2f83032e53950f76fcb734e421b209.png";